import { theme } from '~/theme';

export const useSxStyles = () => {
  return {
    selectStyle: {
      width: theme.spacing(35),
    },
    radioLabel: {
      fontSize: '13px',
      fontWeight: 'bold',
    },
    eclusiveRow: {
      flexBasis: '100%',
      display: 'flex',
      marginTop: '10px',
      padding: '0 8px',
    },
    errorText: {
      color: theme.palette.error.main,
    },
  };
};
